// Import react libs
import { useEffect, useState } from 'react';

// Import services
import {
    getVisitPerDayCount,
    getViewPerProductCount,
    getViewPerLocationCount,
    logProductView as serviceLogProductView,
} from '../services/log';

// ------------------------------------------------------------------------------
// GETTER
// ------------------------------------------------------------------------------
// Hook to get visit per day
export function useGetVisitPerDay() {
    const [visitPerDay, setVisitPerDay] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        setVisitPerDay(null);
        setIsLoading(true);
        setIsError(false);

        async function fetchVisitPerDay() {
            try {
                // Try to get visit per day logs
                const currentVisitPerDay = await getVisitPerDayCount();
                setVisitPerDay(currentVisitPerDay);
            } catch (err) {
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        }

        fetchVisitPerDay();
    }, []);

    return { visitPerDay, isLoading, isError };
}

// Hook to get view per product
export function useGetViewPerProduct() {
    const [viewPerProduct, setViewPerProduct] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        setViewPerProduct(null);
        setIsLoading(true);
        setIsError(false);

        async function fetchViewPerProduct() {
            try {
                // Try to get visit per day logs
                const currentViewPerProduct = await getViewPerProductCount();
                setViewPerProduct(currentViewPerProduct);
            } catch (err) {
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        }

        fetchViewPerProduct();
    }, []);

    return { viewPerProduct, isLoading, isError };
}

// Hok to get visits per day
export function useGetVisitPerLocation() {
    const [visitPerLocation, setVisitPerLocation] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        setVisitPerLocation(null);
        setIsLoading(true);
        setIsError(false);

        async function fetchVisitPerLocation() {
            try {
                // Try to get visit per day logs
                const currentVisitPerLocation = await getViewPerLocationCount();
                setVisitPerLocation(currentVisitPerLocation);
            } catch (err) {
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        }

        fetchVisitPerLocation();
    }, []);

    return { visitPerLocation, isLoading, isError };
}

// ------------------------------------------------------------------------------
// LOGGER
// ------------------------------------------------------------------------------

// Hook to return a product view logguer
export function useLogProductView() {
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    // Function to log the view
    async function logProductView(visitId, productId) {
        setIsLoading(true);
        setIsError(false);

        try {
            // Try to log the visit
            await serviceLogProductView(visitId, productId);
        } catch (err) {
            setIsError(true);
        } finally {
            setIsLoading(false);
        }
    }

    return { logProductView, isLoading, isError };
}
